import { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DarkTheme from './components/DarkTheme';
import './index.css';
import { AuthProvider }       from './context/AuthContext';
import ProtectedRoute         from './components/ProtectedRoute';
import AdminRoute             from './components/AdminRoute';
import AdminPanel             from './pages/AdminPanel';
import Navbar                 from './components/Navbar';
import Hero                   from './components/Hero';
import Features               from './components/Features';
import About                  from './components/About';
import Products               from './components/Products';
import Contact                from './components/Contact';
import Footer                 from './components/Footer';
import Auth                   from './pages/Auth';
import Dashboard              from './pages/Dashboard';
import PulseDashboard         from './pages/PulseDashboard';
import PrivacyPolicy          from './pages/PrivacyPolicy';
import RefundPolicyPage       from './pages/RefundPolicy';
import TermsOfServicePage     from './pages/TermsOfService';
import Pulse                  from './pages/Pulse';
import VerifyEmail            from './pages/VerifyEmail';
import Plans                  from './pages/Plans';
import Toast                  from './components/Toast';

const DARK_ROUTES = ['/auth', '/dashboard', '/pulse'];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function ThemeSync() {
  const { pathname } = useLocation();
  const dark = DARK_ROUTES.some(r => pathname === r || pathname.startsWith(r + '/'));
  useLayoutEffect(() => {
    const color = dark ? '#0f172a' : '#479EC3';
    document.documentElement.style.backgroundColor = color;
    document.body.style.backgroundColor = dark ? '#0f172a' : '';
    const prev = document.querySelector('meta[name="theme-color"]');
    if (prev) prev.remove();
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = color;
    document.head.appendChild(meta);
  }, [dark]);
  return dark ? <DarkTheme /> : null;
}

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Features />
        <Products />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <ThemeSync />
        <Toast />
        <Routes>
          <Route path="/"               element={<Home />} />
          <Route path="/auth"           element={<Auth />} />
          <Route path="/signin"         element={<Navigate to="/auth" replace />} />
          <Route path="/signup"         element={<Navigate to="/auth" replace />} />
          <Route path="/dashboard"      element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/pulse" element={<ProtectedRoute><PulseDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/plans" element={<ProtectedRoute><Plans /></ProtectedRoute>} />
          <Route path="/privacy"        element={<PrivacyPolicy />} />
          <Route path="/refund-policy"  element={<RefundPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/pulse"          element={<Pulse />} />
          <Route path="/verify-email"   element={<VerifyEmail />} />
          <Route path="/admin"          element={<AdminRoute><AdminPanel /></AdminRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
